import React from 'react';
import PropTypes from 'prop-types';

import {connect, dispatch} from 'utils/state_manager';

import {Box, Button, Stack} from 'views/components';
import {ArrowForwardIos} from 'views/icons';
import {Translate, WasHelpfulCard, AiQuestionCard} from 'views/module';

import HowWorksCard from './cards/HowWorksCard';
import ScopeCard from './cards/ScopeCard';
import TitleCard from './cards/TitleCard';
import {primaryButtonSx} from '../../utils/button_styles';

const StartStep = (props) => {
  const {onNext, clientRn} = props;

  return (
    <Stack sx={{gap: '8px'}}>
      <TitleCard />
      <HowWorksCard />
      <ScopeCard />
      <WasHelpfulCard articleTitle="Intake Form | Care Overview | Feedback (Thumbs)" articleRN="RN:ARTICLE-V1-CareOverviewHelpful" />
      <AiQuestionCard clientRn={clientRn} page='Intake Form | Care Overview' />

      <Box sx={{textAlign: 'right', mt: '24px'}}>
        <Button onClick={onNext} sx={primaryButtonSx} endIcon={<ArrowForwardIos />}>
          <Translate expression={'startstep.StartStep.CreateQuote'} />
        </Button>
      </Box>
    </Stack>
  );
};

StartStep.propTypes = {
  onNext: PropTypes.func,
  clientRn: PropTypes.string,
};

const mapStateToProps = (state) => ({
  clientRn: state.user.clientRn,
});

export default connect(mapStateToProps, dispatch)(React.memo(StartStep));
